import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const LEARNING_PAGE_SIDEBAR_WIDTH = 320;
const LearningPageSidebar = ({
  children,
  id,
  withSubNav
}) => /*#__PURE__*/_jsx(View, {
  backgroundColor: "fill-surface-default",
  blockSize: `calc(100vh - ${withSubNav ? '126px' : '86px'})`,
  borderColor: "border-core-default",
  borderInlineEndStyle: "solid",
  borderInlineEndWidth: "100",
  id: id,
  insetBlockStart: withSubNav ? '126px' : '86px',
  maxInlineSize: `${LEARNING_PAGE_SIDEBAR_WIDTH}px`,
  minInlineSize: `${LEARNING_PAGE_SIDEBAR_WIDTH}px`,
  overflowY: "auto",
  position: "sticky",
  children: children
});
export default LearningPageSidebar;